import { useState } from "react";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { Button } from "antd";

const FullscreenButton = () => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  const toggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        // Enter fullscreen
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } else {
        // Exit fullscreen
        await document.exitFullscreen();
        setIsFullscreen(false);
      }
    } catch (error) {
      console.error("Error toggling fullscreen:", error);
    }
  };

  return (
    <Button
      type="text"
      shape="circle"
      icon={isFullscreen ? <FullscreenExitOutlined 
        style={{ fontSize: "20px" , cursor: "pointer" , color: "white" }}
        /> : <FullscreenOutlined 
        
        style={{ fontSize: "20px" , cursor: "pointer", color: "white"}} 
        />}
      onClick={toggleFullscreen}
      aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
    />
  );
};

export default FullscreenButton;
